module.exports = __webpack_public_path__ + "static/media/bpossc.2bee37b8.svg";